module.exports = __webpack_public_path__ + "img/bodega.8ff6d744.jpg";